@if (component) {
<div class="p-t-11 p-b-7 bg-col-51"
     [scrollNavTarget]="'Features' | translate">
    <!-- title -->
    <h2 class="h1 center col-1"
        *iCms="'title' of component; skipEmpty:true"></h2>
    <!-- tabs -->
    @if (component.productFeaturesTabs) {
    <div class="p-t-4">
        <!-- headers -->
        <div class="w-12 pos-relative center _shadow"
             dragScroll>
            @for (tab of component.productFeaturesTabs; track $index; let isLast = $last; let isFirst = $first; let i =
            $index) {
            <div class="b-a h5 cursor-pointer no-wrap inline-block _tab"
                 [style.marginRight.px]="!isLast ? 10: 0"
                 [class.m-r]="isLast"
                 [class.m-l]="isFirst"
                 [zippyClass]="'!bg-col-52 bg-col-11 !col-1 col-w !b-col-12 b-col-11'"
                 [zippyOpen]="['product_features_tabs', uid, i]"
                 *iCms="'tabTitle' of tab">
            </div>
            }
        </div>
        <!-- content -->
        @if (productFeatures) {
        <div class="wrap-x w-12 pos-relative m-t-10 flex-x flex-justify-center">
            @for (tab of productFeatures; track $index; let i = $index) {
            <div class="flex flex-column-s flex-middle flex-justify-center w-12 w-10-x"
                 [style.gap.px]="client.isS ? 30 : 118"
                 [zippy]="['product_features_tabs', uid, i]"
                 [zippyAuto]="true">
                <!-- image -->
                @if (tab.image) {
                <div class="w-6 w-12-s wrap-s">
                    <div class="ratio-1-1 pos-relative">
                        <div class="fill">
                            @for (hotspot of tab.hotSpots; track $index; let j = $index) {
                            <button class="_button pos-absolute z-1"
                                    [style.gap.px]="10"
                                    (click)="unzoom(i)"
                                    [toggle]="['hotspot' + i, j]"
                                    [toggleClass]="'!none flex flex-middle flex-justify-center'"
                                    [toggleClassBy]="['hotspot' + i, j]">
                                <i class="_icon inline-flex flex-middle icon-full-arrow"></i>
                                <p class="h5">
                                    {{'Back' | translate}}
                                </p>
                            </button>
                            }
                            <div class="pos-relative ratio-1-1 w-12 _imageContainer">
                                <img #mainImage
                                     class="rf _mainImage"
                                     [image]="tab.image"
                                     [options]="{fillColor: 'transparent'}">
                                @if (tab.hotSpots.length) {
                                @for (hotspot of tab.hotSpots; track $index; let j = $index) {
                                @if (hotspot.zoomedImage) {
                                <img class="rf _zoomedImage"
                                     [toggleClass]="'_zoomActive'"
                                     [toggleClassBy]="['hotspot' + i, j]"
                                     [image]="hotspot.zoomedImage"
                                     [options]="{fillColor: 'transparent'}">
                                }
                                <hot-spot class="pos-absolute"
                                          [title]="hotspot.title"
                                          [style.top.%]="(hotspot.verticalPosition || 0)"
                                          [style.left.%]="(hotspot.horizontalPosition || 0)"
                                          [toggle]="['hotspot' + i, j]"
                                          [toggleClassBy]="['hotspot' + i, j]"
                                          [toggleClass]="'is-active'"
                                          (click)="hotSpotClickHandler(i, hotspot.horizontalPosition, hotspot.verticalPosition)"
                                          [positionY]="hotspot.verticalPosition"
                                          [positionX]="hotspot.horizontalPosition">
                                </hot-spot>
                                }
                                }
                            </div>
                        </div>
                    </div>
                </div>
                }
                <div class="w-3 w-12-s wrap-s _descriptionContainer">
                    <div class="w-12 _mainDescription">
                        <ng-container *ngTemplateOutlet="tabDescription; context: {tab: tab, isHotSpot: false}">
                        </ng-container>
                    </div>
                    @if (tab.hotSpots.length) {
                    @for (hotspot of tab.hotSpots; track $index; let j = $index) {
                    <div class="w-12 _hotspotDescription"
                         [toggleClass]="'!ng-hide _hotspotDescriptionVisible'"
                         [toggleClassBy]="['hotspot' + i, j]">
                        <ng-container
                                      *ngTemplateOutlet="tabDescription; context: {tab: hotspot, isHotSpot: true, j: j}">
                        </ng-container>
                    </div>
                    }
                    }
                </div>
            </div>
            }
        </div>
        }
    </div>
    }
</div>
}


<ng-template #tabDescription
             let-tab="tab"
             let-isHotSpot="isHotSpot"
             let-j="j">
    <div class="p-a-10 p-a-4-s bg-col-w">
        <div class="flex flex-middle flex-justify-between">
            <!-- title -->
            <h2 class="col-1 inline-block"
                [ngClass]="client.isS ? 'h2' : 'h3'"
                *iCms="'title' of tab; skipEmpty: true"></h2>
            @if (tab.showIcon) {
            <div class="icon ratio-1-1 inline-flex _descriptionIcon">
                <img class="rf"
                     [image]="tab.icon">
            </div>
            }
        </div>
        <!-- description -->
        @if (tab.description && !isHotSpot) {
        <div>
            <p class="p2 m-t-5"
               *iCms="'description' of tab">
            </p>
            @if (tab.hotSpots?.length) {
            <ul class="m-t-5">
                @for (hotspot of tab.hotSpots; track $index; let first = $first) {
                <li class="h5"
                    *iCms="'title' of hotspot"
                    [class.m-t-2]="!first"></li>
                }
            </ul>
            }
        </div>
        }
        @if (tab.descriptionType === 'text' && tab.descriptionText && isHotSpot) {
        <p class="p2 m-t-5"
           *iCms="'descriptionText' of tab">
        </p>
        }
        @if (tab.descriptionType === 'list' && tab.descriptionList && isHotSpot) {
        <ul class="p2 m-t-5">
            @for (copy of tab.descriptionList; track $index) {
            <li *iCms="'text' of copy"></li>
            }
        </ul>
        }

        <!-- button -->
        @if (tab.ctaCopy && tab.ctaLink) {
        <href [link]="tab.ctaLink">
            <button class="button m-t-5">
                <span *iCms="'ctaCopy' of tab">
                </span>
            </button>
        </href>
        }
    </div>
</ng-template>